import React from 'react';
import { FormattedMessage } from 'react-intl';

const useDefaultEmptyFieldError = (required = true) => ({
  required,
  message: <FormattedMessage id="commons.form.errors.requiredField" />,
});

export default useDefaultEmptyFieldError;
